export default "__VITE_ASSET__Dy6sgtxi__"